<template>
  <div class="hello">
    <Navbar></Navbar>
    <h4
      class="card-title"
      style="padding-top:30px;padding-bottom:30px;background-color:#c3c3c338;"
    ><a href="/faq" style="color:#010101 !important;">FAQ </a>: Venom & Snakebites</h4>
    <div class="container">
      <div class="row">
        <div class="col-md-4" style="text-align:justify;">
           
             <p>The venom of a snake is produced by a modified salivary gland and contains zootoxins. The venom is used for hunting prey and as a defense mechanism.   A snake can inject its venom into the targets body using modified teeth – fangs.  The venom largely affects the functioning of the nervous or circulatory system and disrupts their normal functions and causes organ failure which may cause death or paralysis of the target. People get bitten by snakes as a result of accidental encounters with snakes where the snake defends its life. Snakebites can be successfully treated in hospitals using anti-venom.
                 </p>
                 <img src="../assets/snakebite-FAQ--2.jpg" width="100%" height="auto"><br><br>
                  <img src="../assets/snakebite-FAQ--1.jpg" width="100%" height="auto"><br><br>
                   <img src="../assets/snakebite-FAQ--3.jpg" width="100%" height="auto">
        </div>
        <div class="col-md-8">
            <b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion1 variant="secondary" style="text-align:left;">
   Which is the most venomous snake found in India?                                      
     <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>

<b-collapse id="accordion1" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
    <div class ="row">
        <div class="col-md-4">
            <img src="../assets/Krait---most-venomous-snake-india.jpg" width="100%" height="auto">
            </div>
            <div class="col-md-8">
                The venom of kraits is more potent than other species of snakes and they should be considered the most venomous snakes found in India. In general, any snake that has venom which can kill a human being should be treated with extreme caution.
                </div>
                </div>
   </b-collapse>
            </b-card>
  <b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion2 variant="secondary" style="text-align:left;">
  What is the treatment for snakebites?
     <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
        
<b-collapse id="accordion2" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
  Antivenom is the only proven treatment for venomous snakebites. It is also called anti-snake venom (ASV) or antivenin. Antivenom should be administered by a doctor and also may need some additional supportive treatment depending on age of victim and amount of venom entering the bloodstream. <u>There is no other proven medicine to treat snakebites.</u> In India, we currently use polyvalent ASV which is effective for a broad range of venomous snakebite treatments. Antivenom is actually antibodies that work by neutralizing venom antigen in the bloodstream of the patient – the same working concept as vaccinations.
</b-collapse>
  </b-card>

  <b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab" style="text-align:left;">
 <b-btn block href="#" v-b-toggle.accordion3 variant="secondary" style="text-align:left;">
  What is the best first aid for snakebites?        
     <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
        
<b-collapse id="accordion3" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
 The best first aid measures are as follows:<br>
Ensure that the person with the suspected bite remains calm.<br>
Immobilize with the bitten area (see video/poster on immobilizing bite area).<br>
Transport victim immediately to the nearest hospital where anti-venom is available. DO NOT make the patient walk or exert in any way that will increase heartbeat.<br>
DO NOT wash the wound or apply anything (ointment, herbal paste etc) on the suspected snakebite. <br>
The Golden Hour is the first 60 minutes after the bite when antivenom is most effective. The key to saving a snakebite victim is to get the patient to the nearest hospital within that window.

</b-collapse>
  </b-card>

<b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion4 variant="secondary" style="text-align:left;">
  Is a newborn cobra  venomous?           
     <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
<b-collapse id="accordion4" role="tabpanel" style="padding-left: 10px;padding-right: 10px;">
 Yes – all the newborn hatchlings of venomous species have active venom glands and operational fangs at the time of birth.
 That means a newborn cobra can deliver a fatal dosage of venom to a human.
 </b-collapse>
  </b-card>


<b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion5 variant="secondary" style="text-align:left;">
  How many people die in India every year due to snakebite?         
     <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
        
<b-collapse id="accordion5" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
 As per studies conducted, every year more than 45,000 people across India die due to venomous snakebite. Most of these deaths occur due to unscientific and/or delayed treatment. Snakebite is considered as an important medical challenge by the World Health Organization and India tops the list of countries with snakebite mortality.
</b-collapse>
  </b-card>

  <b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion6 variant="secondary" style="text-align:left;">
  Which are the Big4 snakes found in India?         
     <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
        
<b-collapse id="accordion6" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
 The’Big Four‘ is a collective term used for common cobra, Russell's viper, common krait and saw-scaled viper which are the most common venomous snakes found across  India and are collectively responsible for more than 90% of snakebite mortality and morbidity. These snakes have adapted to survive alongside humans in farmlands, households, godowns, and even in busy urban environments.
</b-collapse>
  </b-card>

    <b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion7 variant="secondary" style="text-align:left;">
  How effective are traditional healing methods? I know about people who have been cured by traditional healers.         
     <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
        
<b-collapse id="accordion7" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
None of the traditional healing methods are scientifically proven and using un-scientific methods to treat a person who bitten by a venomous snake (eg. cobra) is certainly dangerous. <br><br>
The enviable ‘success’ rate for traditional healers has an important reason. 90-95% of snakebites are usually from non-venomous snake species, ie 9 out of 10 bites are harmless. So, when a snakebite victim goes to a traditional healer with a non-venomous bite, he is ‘cured’ by the healer. The less fortunate victim who was bitten by a venomous snake will simple get more and more ill until the healer proclaims that the victim and/or family has offended the Gods and is beyond human help! In some cases a victim sustaining a venomous snakebite may also be ‘cured’. This would be either because the bite was a ‘dry bite’ with no venom being injected or else the amount of venom injected was too less to cause significant damage. In such cases also the traditional healer will claim success. In this way, the traditional healer has a success rate of more than 90%. <br><br>
Sadly, once the traditional healer has washed his hands off the seriously ill venomous snakebite victim, the family will rush him to the hospital. Usually by this time, many hours will have passed since the bite and the venom will have damaged multiple organs so severely that even high doses of antivenom cannot reverse the process. Word spreads in the community about this snakebite victim who died in hospital and people will wonder why the patient was NOT taken to the faith healer who had cured most of his patients. Only better awareness only can save us from this deadly circle of death. 

</b-collapse>
  </b-card>

   <b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion8 variant="secondary" style="text-align:left;">
  Someone told me that the anti venom available in India is not effective against all snakebites. Is that correct?
   <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
        
<b-collapse id="accordion8" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
Currently in India, we use polyvalant antivenom which is the ONLY type of antivenom used by hospitals to treat snakebites. These antivenom is has anti-bodies which can neutralize venoms of the Big4 snakes found in India. But, there are more than fifteen different species of medically important snakes in India and their venom components are not exactly the same as that of the Big4 snakes. The current anti venom can neutralize some parts of these non-Big4 venoms which will help in the recovery of the patient. Recent studies also showed that the venom composition of the Big4 also changes from region to region and that antivenom made from venom collected from a single location may not be as good as we have been assuming. There is, therefore, a need for region-specific anti venom and a number of research projects are being undertaken with the aim of developing more potent and specific anti venoms.
</b-collapse>
  </b-card>

    <b-card no-body class="mb-1" style="text-align: left;">
      <b-card-header header-tag="header" class="p-1" role="tab">
 <b-btn block href="#" v-b-toggle.accordion9 variant="secondary" style="text-align:left;">
  What is the difference between venomous and poisonous ?
   <span class="when-opened" style="float:right;">
           <font-awesome-icon icon="minus-square" />
     </span>
     <span class="when-closed" style="float:right;">
       <font-awesome-icon icon="plus-square" />
     </span>
</b-btn>
      </b-card-header>
        
<b-collapse id="accordion9" role="tabpanel" style="padding-left: 10px;
    padding-right: 10px;">
Snakes are not poisonous but they are venomous. Venomous snakes are often referred to as ‘poisonous snakes ‘ which is wrong. A poison may cause damage even if it does not actually enter the blood stream, but venoms can affect the victim only if it enters the circulatory system. Snakes do not carry poison; they carry venom which is harmful only when injected into the circulatory system of the target. An animal or plant can be termed poisonous when it produces toxins which can be harmful if the target come into direct contact with it or consumes the same. Some mushrooms and frogs are poisons as they produce harmful toxins; the term ‘poisonous’ can be used for them, but not for snakes.
</b-collapse>
  </b-card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "./navbar";
export default {
  components: {
    Navbar
  },
  data() {
    return {
         text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
    };
  },
};
</script>
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #ffffff;
}
.collapsed > .when-opened,
    :not(.collapsed) > .when-closed {
        display: none;
    }
    .btn-secondary:hover {
    color: #fff;
    background-color: #785432;
    border-color: #785432;
}
  .btn-secondary {
    color: #fff;
    background-color: #785432;
    border-color: #785432;
}
.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
    color: #fff;
    background-color: #785432;
    border-color: #785432;
}
</style>